import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';


@Injectable()
export class SessionExpiredService {
    isSessionExpired= new ReplaySubject<boolean>();

    constructor(){
        this.isSessionExpired.next(false);
    }
}
